import React from 'react';

import { Block, withBlockRendering } from '../common/Block.jsx';
import { Builder, EmptyPlaceholder } from '../layout/Builder.jsx';
import { Wrapper as ButtonWrapper, withBlockTypeConfigPropsV2 } from '../common/Button.jsx';
import { InventoryLineItemCellContainer, PromoCodeLineItemCellContainer } from './CartLineItemCell.jsx';
import Defaults from '../layout/Defaults.jsx';
import FormField from '../common/FormField.jsx';
import { default as InventoryHelper } from '../common/Inventory.jsx';
import Name from '../common/Name.jsx';
import PageType from '../common/PageType.jsx';
import Token from '../common/Token.jsx';
import Utilities from '../common/Utilities.jsx';

const Mode = {
    checkout: 'checkout',
    emptyCart: 'empty_cart',
    purchaseConfirmation: 'purchase_confirmation'
}
let _CartControllerInst;
function _CartController(props) {
    React.useEffect(() => {
        _CartControllerInst = true;
        return () => _CartControllerInst = undefined
    }, []);

    const getQuery = () => {
        if (!window || !window.location || !window.location.search) {
            return null;
        }
        return Utilities.parseQueryString(window.location.search.substring(1));
    }
    const updateQuery = (newEditions) => {
        if (!window) {
            return;
        }
        if (window.history && window.history.replaceState) {
            // TODO do we want to do this?
            window.history.replaceState({}, document.title, cart.formatUrl(newEditions, props.querySub));
        } else if (window.location) {
            window.location.href = cart.formatUrl(newEditions, props.querySub);
        }
    }

    // Editions
    const [editionIdString, setEditionIdString] = React.useState(undefined);
    const [editions, setEditions] = React.useState([]);
    React.useEffect(() => {
        let _editions = [];
        if (props.builder) {
            if (props.data && props.data.editionId) {
                _editions.push({ EditionId: props.data.editionId, Quantity: 1 });
            }
        } else {
            const query = getQuery();
            if (query && query.editionId) {
                if (Array.isArray(query.editionId)) {
                    _editions = query.editionId;
                } else {
                    _editions.push(query.editionId);
                }
            }
            if (window && window.location && window.location.pathname) {
                const segments = window.location.pathname.split('/');
                const lastSegment = segments.pop() || segments.pop();
                const parsed = parseInt(lastSegment, 10);
                if (!isNaN(parsed)) {
                    _editions.push(parsed);
                }
            }
            let localEditions = cart.getItemsFromStorage();
            if (localEditions && !Array.isArray(localEditions)) {
                localEditions = Object.keys(localEditions).map(d => ({ EditionId: d, Quantity: 1 }))
            }
            const newEditions = [];
            _editions.forEach(d => {
                let found = false;
                for (let i = 0; i < localEditions.length; i++) {
                    if (localEditions[i].EditionId != d) {
                        continue;
                    }
                    found = true;
                    newEditions.push(localEditions[i]);
                    break;
                }
                if (!found) {
                    newEditions.push({ EditionId: d, Quantity: 1 });
                }
            })
            cart.setItems(newEditions, props.querySub);
            _editions = [...newEditions];

            if (_editions.length == 0) {
                const promoCodeId = cart && cart.getPromoCodeFromStorage();
                if (promoCodeId) {
                    setCartData({ promoCode: { promoCodeId } });
                } else {
                    setCartData({});
                }
                return;
            }
        }
        setEditions(_editions);
    }, []);
    const handleEditionRemove = (editionId) => {
        const _editions = [];
        const localEditions = cart.getItemsFromStorage();
        localEditions.forEach(d => {
            if (editionId !== d.EditionId) {
                _editions.push(d);
            }
        })
        cart.setItems(_editions, props.querySub);
        setEditions(_editions);
        getCart({ requestEditions: _editions });
        updateQuery(_editions);
    }
    const handleLineItemQuantityBlur = (editionId) => {
        let _cartData = cartData;
        let edition;
        for (let i = 0; i < _cartData.lineItems.length; i++) {
            edition = InventoryHelper.edition(_cartData.lineItems[i].inventory);
            if (!edition || edition.editionId != editionId) {
                continue;
            }
            if (_cartData.lineItems[i].quantity) {
                // Refresh cart with updated quantity
                getCart({ requestEditions: editions });
                return;
            }

            // Quantity was empty on blur => Reset to what's in local storage
            const localEditions = cart.getItemsFromStorage();
            for (let i = 0; i < localEditions.length; i++) {
                if (localEditions[i].EditionId != editionId) {
                    continue;
                }
                _cartData.lineItems[i].quantity = localEditions[i].Quantity;
                setCartData({ ..._cartData });
                break;
            }
            break;
        }
    }
    const handleLineItemQuantityChange = (editionId, quantity) => {
        let _cartData = cartData;
        let edition;
        for (let i = 0; i < _cartData.lineItems.length; i++) {
            edition = InventoryHelper.edition(_cartData.lineItems[i].inventory);
            if (!edition || edition.editionId != editionId) {
                continue;
            }
            _cartData.lineItems[i].quantity = quantity;
            setCartData({ ..._cartData });
            break;
        }
        if (!quantity) {
            return;
        }
        const localEditions = cart.getItemsFromStorage();
        for (let i = 0; i < localEditions.length; i++) {
            if (localEditions[i].EditionId != editionId) {
                continue;
            }
            localEditions[i].Quantity = quantity;
            cart.setItems(localEditions, props.querySub);
            setEditions(localEditions);
            break;
        }
    }
    const isEmpty = editions.length == 0;

    // Cart
    const [cartData, setCartData] = React.useState(undefined);
    const getCart = ({ requestEditions, promoCodeId }, callback) => {
        let _promoCodeId = promoCodeId;
        if (!_promoCodeId && cartData && cartData.promoCode) {
            _promoCodeId = cartData.promoCode.promoCodeId;
        }
        const requestData = { Sub: props.config.subdomain };
        if (_promoCodeId) {
            requestData.PromoCodeId = _promoCodeId;
        }
        requestData.Editions = requestEditions || editions;
        let route = '/api/carts';
        if (props.handlerUrl) {
            route = props.handlerUrl + route;
        }
        $.post(
            route,
            requestData,
            (responseData) => {
                const updatedEditions = [];
                for (var i = 0; i < responseData.lineItems.length; i++) {
                    const item = responseData.lineItems[i];
                    if (!item || !item.inventory) {
                        continue;
                    }
                    updatedEditions.push({ EditionId: item.inventory.editions[0].editionId, Quantity: item.quantity });
                }
                if (!_CartControllerInst) {
                    return;
                }
                if (props.builder && responseData.hasActivePromoCodes) {
                    responseData.promoCode = props.data && props.data.promoCode;
                }
                setCartData(responseData);
                setEditions(updatedEditions);

                if (!props.builder) {
                    cart.setItems(updatedEditions, props.querySub);
                }
                if (callback) {
                    callback(responseData);
                }
            });
    }
    React.useEffect(() => {
        if (editions.length == 0 || cartData && cartData.lineItems) {
            return;
        }
        const idString = editions.map(d => d.EditionId).join('-');
        if (idString == editionIdString) {
            return;
        }
        setEditionIdString(idString);

        let promoCodeId;
        if (!cartData && !props.builder) {
            promoCodeId = cart && cart.getPromoCodeFromStorage();
        }
        getCart({ requestEditions: editions, promoCodeId });
    }), [editions];

    // Promo Code
    const handlePromoCodeRemove = () => {
        if (!cartData || !cartData.promoCode) {
            return;
        }
        if (!props.builder) {
            cart.setPromoCode(undefined);
        }
        cartData.promoCode = undefined;
        getCart({});

        // Force the UI to update
        const _cartData = { ...cartData };
        setCartData(_cartData);
    }

    // Billing
    const [billingInfo, setBillingInfo] = React.useState({ data: {} });
    const handleBillingInfoChange = (data) => {
        setBillingInfo({ data, formState: billingInfo.formState });
    }
    const refSubmit = React.useRef(undefined);
    const validateBillingInfo = () => {
        if (!refSubmit || !refSubmit.current) {
            return false;
        }
        if (refSubmit.current.checkValidity()) {
            return true;
        }
        const temp = document.createElement('button')
        refSubmit.current.appendChild(temp)
        temp.click()
        refSubmit.current.removeChild(temp)
        return false;
    }
    React.useEffect(() => {
        if (!billingInfo.paymentToken) {
            return;
        }
        // Apple Pay (billing info set inside payment request handler)
        if (validateBillingInfo()) {
            getCart({ requestEditions: editions }, (updatedCart) => submitPaymentToken(billingInfo.paymentToken, updatedCart, billingInfo.paymentTokenCallback))
        } else {
            setBillingInfo({ data: billingInfo.data, formState: 'form' });
        }
    }, [billingInfo]);

    // Payment
    const [applePay, setApplePay] = React.useState({ data: {}, state: 'hidden' });
    const handleApplePay = () => {
        if (!cartData.config) {
            return;
        }
        setBillingInfo({ data: billingInfo.data, formState: 'processing' });

        const paymentRequest = {
            countryCode: 'US',
            currencyCode: cartData.config.currencyCode.toUpperCase(),
            requiredShippingContactFields: ['postalAddress', 'phone', 'email', 'name'],
            total: {
                label: window.location.hostname,
                amount: cartData.totals && cartData.totals.subtotal && cartData.totals.subtotal.value
            }
        };
        const paymentSession = window.Stripe.applePay.buildSession(paymentRequest, function (result, completion) {
            let data = billingInfo.data;
            if (!result || !result.token) {
                setBillingInfo({ data: data, error: 'Unable to obtain payment token for Apple Pay.', formState: 'error' });
                return;
            }
            if (result && result.shippingContact) {
                data = {
                    City: result.shippingContact.locality,
                    Country: result.shippingContact.countryCode,
                    Email: result.shippingContact.emailAddress,
                    FirstName: result.shippingContact.givenName,
                    LastName: result.shippingContact.familyName,
                    Phone: result.shippingContact.phoneNumber,
                    State: result.shippingContact.administrativeArea,
                    Zip: result.shippingContact.postalCode
                };
                if (result.shippingContact.addressLines.length > 0) {
                    data.AddressLineOne = result.shippingContact.addressLines[0];
                }
                if (result.shippingContact.addressLines.length > 1) {
                    data.AddressLineTwo = result.shippingContact.addressLines[1];
                }
            }
            const callback = function (success) {
                completion(success ? ApplePaySession.STATUS_SUCCESS : ApplePaySession.STATUS_FAILURE);
            }
            setBillingInfo({
                data: data,
                paymentToken: result.token && result.token.id,
                paymentTokenCallback: callback,
                formState: 'processing'
            });
        }, function(error) {
            console.log(error.message);
            const e = `Apple Pay error: ${error.message}`;
            setBillingInfo({ data: billingInfo.data, error: e, formState: 'error' });
        });
        paymentSession.oncancel = () => { setBillingInfo({ data: billingInfo.data, error: 'Cancelled Apple Pay', formState: 'error' }); }
        paymentSession.begin();
    }
    const handlePurchase = (_, e) => {
        if (e) {
            e.preventDefault();
        }
        if (!validateBillingInfo()) {
            return;
        }
        if (!Stripe) {
            setBillingInfo({ data: billingInfo.data, error: 'Could not find Stripe library. Please ensure you have disabled any browser plug-ins and try again.', formState: 'error' });
            return;
        }
        setBillingInfo({ data: billingInfo.data, formState: 'processing' });

        let exp = billingInfo.data.Expiration;
        if (exp && !exp.includes('/') && !exp.includes(' ')) {
            if (exp.length === 3) {
                exp = `${exp[0]}/${exp.substring(1)}`;
            } else if (exp.length === 4) {
                exp = `${exp.substring(0, 2)}/${exp.substring(2)}`;
            }
        }

        getCart({ requestEditions: editions }, (updatedCart) => {
            if (updatedCart.hasError) {
                setBillingInfo({ data: billingInfo.data });
                return;
            }
            Stripe.card.createToken(
                {
                    cvc: billingInfo.data.CVC,
                    exp: exp,
                    number: billingInfo.data.PaymentAccount,
                    address_zip: billingInfo.data.Zip
                },
                (_, response) => {
                    if (response.error) {
                        setBillingInfo({ data: billingInfo.data, error: response.error.message, formState: 'error' });
                        return;
                    }
                    submitPaymentToken(response.id, updatedCart)
                }
            );
        });
    }
    const submitPaymentToken = (token, updatedCart, callback) => {
        if (updatedCart.hasError) {
            setBillingInfo({ data: billingInfo.data });
            return;
        }
        const postData = {
            AddressLineOne: billingInfo.data.AddressLineOne,
            AddressLineTwo: billingInfo.data.AddressLineTwo,
            City: billingInfo.data.City,
            Country: billingInfo.data.Country,
            Email: billingInfo.data.Email,
            FirstName: billingInfo.data.FirstName,
            LastName: billingInfo.data.LastName,
            LineItems: editions,
            Notes: billingInfo.data.Notes,
            Phone: billingInfo.data.Phone,
            PromoCodeId: updatedCart.promoCode && updatedCart.promoCode.promoCodeId,
            State: billingInfo.data.State,
            Sub: props.config.subdomain,
            Token: token,
            Zip: billingInfo.data.Zip
        };
        if (window && window.cookie) {
            postData.Referrer = cookie.getCookie(cookie._referrer);
            postData.Utm = cookie.getCookie(cookie._utm);
        }
        if (!billingInfo.data[FormField[Name.Block.Cart.CardForm.Container].SameAddressCheckbox]) {
            postData.BillingAddressLineOne = billingInfo.data.BillingAddressLineOne;
            postData.BillingAddressLineTwo = billingInfo.data.BillingAddressLineTwo;
            postData.BillingCity = billingInfo.data.BillingCity;
            postData.BillingCountry = billingInfo.data.BillingCountry;
            postData.BillingState = billingInfo.data.BillingState;
            postData.BillingZip = billingInfo.data.BillingZip;
        }
        $.post(
            '/api/buy',
            postData,
            () => {
                cart.setItems([], props.querySub);
                cart.setPromoCode(undefined);
                updateQuery([]);
                setBillingInfo({ data: {}, formState: 'success' });
                if (window) {
                    window.scrollTo(0, 0);
                }
                const totals = updatedCart.totals || {};
                if (window && window.ga) {
                    try {
                        const transactionId = Utilities.uuidv4();
                        ga('require', 'ecommerce');
                        ga('ecommerce:addTransaction', {
                            id: transactionId,                                  // Transaction ID. Required.
                            affiliation: 'ArtCloud',                            // Affiliation or store name.
                            revenue: totals.subtotal && totals.subtotal.value,  // Grand Total.
                            shipping: totals.shipping && totals.shipping.value, // Shipping.
                            tax: totals.tax && totals.tax.value                 // Tax.
                        });
                        let item, inventory;
                        for (let i = 0; i < updatedCart.lineItems.length; i++) {
                            item = updatedCart.lineItems[i];
                            inventory = item.inventory || {};
                            ga('ecommerce:addItem', {
                                id: transactionId,                           // Transaction ID. Required.
                                category: null,                              // Category or variation.
                                name: inventory.title,                       // Product name. Required.
                                price: item.subtotal && item.subtotal.value, // Unit price.
                                quantity: item.quantity,                     // Quantity.
                                sku: inventory.sku || inventory.inventoryId  // SKU/code.
                            });
                        }
                        ga('ecommerce:send');
                    } catch (e) { }
                }

                if (window && window.gtag) {
                    try {
                        const items = updatedCart.lineItems.map((d, i) => {
                            const inventory = d.inventory || {};
                            return {
                                id: inventory.sku || inventory.inventoryId,
                                list_position: i + 1,
                                name: inventory.title,
                                price: d.subtotal && d.subtotal.value,
                                quantity: d.quantity,
                                variant: inventory.medium
                            }
                        })
                        const transactionId = Utilities.uuidv4();
                        gtag('event', 'purchase', {
                            transaction_id: transactionId,
                            affiliation: 'ArtCloud',
                            currency: 'USD',
                            items: items,
                            tax: totals.tax && totals.tax.value,
                            shipping: totals.shipping && totals.shipping.value,
                            value: totals.subtotal && totals.subtotal.value
                        });
                    } catch (e) { }
                }

                try {
                    const items = updatedCart.lineItems.map(d => {
                        const inventory = d.inventory || {};
                        return {
                            category: null,
                            name: inventory.title,
                            price: d.subtotal && d.subtotal.value,
                            quantity: d.quantity,
                            sku: inventory.sku || inventory.inventoryId
                        }
                    })
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'purchase',
                        transactionId: Utilities.uuidv4(),
                        transactionAffiliation: 'ArtCloud',
                        transactionProducts: items,
                        transactionShipping: totals.shipping && totals.shipping.value,
                        transactionTax: totals.tax && totals.tax.value,
                        transactionTotal: totals.subtotal && totals.subtotal.value
                    });
                } catch (e) { }

                if (window && window.fbq) {
                    try {
                        const contents = updatedCart.lineItems.map((d, i) => {
                            const inventory = d.inventory || {};
                            return {
                                id: inventory.sku || inventory.inventoryId,
                                quantity: d.quantity
                            }
                        })
                        fbq('track', 'Purchase', {
                            value: totals.subtotal && totals.subtotal.value,
                            currency: 'USD',
                            num_items: updatedCart.lineItems.length,
                            contents: contents
                        });
                    } catch (e) { }
                }
                if (window && window.pintrk) {
                    try {
                        const lineItems = updatedCart.lineItems.map((d, i) => {
                            const inventory = d.inventory || {};
                            return {
                                product_name: inventory.title,
                                product_id: inventory.editions && inventory.editions.length > 0 && inventory.editions[0].editionId,
                                product_price: d.subtotal && d.subtotal.value,
                                product_quantity: d.quantity
                            };
                        })
                        pintrk('track', 'checkout', {
                            value: totals.subtotal && totals.subtotal.value,
                            currency: 'USD',
                            order_id: Utilities.uuidv4(),
                            property: 'ArtCloud',
                            line_items: lineItems
                        });
                    } catch (e) { }
                }
 
                if (callback) {
                    callback(true);
                }
                const query = getQuery();
                if (!query || !query.redirectUrl) {
                    return;
                }
                alert(`Thank your for your purchase! You are being redirected to ${query.redirectUrl}.`);
                window.location.href = query.redirectUrl;
            }
        ).fail(jqXHR => {
            setBillingInfo({
                data: billingInfo.data,
                error: jqXHR && jqXHR.responseText
                    ? jqXHR.responseText
                    : 'An error has occurred. Please wait a moment and try again.',
                formState: 'error'
            });

            if (callback) {
                callback(false);
            }
        });
    }
    if (typeof window !== 'undefined') {
        React.useEffect(() => {
            if (!window.Stripe) {
                return;
            }
            try {
                window.Stripe.setPublishableKey(props.config.stripePublishableKey);
                window.Stripe.applePay.stripeAccount = props.config.stripeAccountId;
                window.Stripe.applePay.checkAvailability((available) => setApplePay({ data: applePay.data, state: available ? 'form' : 'hidden' }));
            }
            catch (ex) {
                console.log(ex);
            }
        }, [window.Stripe]);
    }

    // Block Rendering
    const currentState = (props) => {
        if (!props.data || !props.data.config) {
            return;
        }
        if (editions.length > 0 && billingInfo.formState != 'success' && props.data.config[Mode.checkout]) {
            return Mode.checkout;
        } else if (editions.length == 0 && billingInfo.formState != 'success' && props.data.config[Mode.emptyCart]) {
            return Mode.emptyCart;
        } else if (billingInfo.formState == 'success' && props.data.config[Mode.purchaseConfirmation]) {
            return Mode.purchaseConfirmation;
        }
    }
    const state = currentState(props);
    const data = props.data || {};
    let backgroundColor = props.backgroundColor;
    let blocks, pageProps;
    if (cartData && data.config) {
        const mode = props.builder ? props.mode : state;
        if (mode && data.config[mode]) {
            blocks = data.config[mode].blocks;
        }
        if (props.onPageProps) {
            pageProps = props.onPageProps();
        } else {
            pageProps = data.config[mode] && data.config[mode].page;
        }
        backgroundColor = pageProps && pageProps.config && pageProps.config.block && pageProps.config.block.backgroundColor || backgroundColor;
        if (pageProps && pageProps.config) {
        }
    }
    React.useEffect(() => {
        if (props.builder) {
            return;
        }
        const state = currentState(props);
        if (!state) {
            return;
        }
        document.body.style.backgroundColor = props.data.config[state].page.config.block.backgroundColor || '';
    }, [isEmpty, billingInfo.formState]);
    if (!blocks) {
        return null;
    }
    const disabled = billingInfo.formState == 'processing' || billingInfo.formState == 'success';
    let content = props.onBlockRendering(
        PageType.Cart,
        blocks,
        (d) => {
            if (!d.type) {
                return;
            }
            switch (d.type.value) {
                case Name.Block.Cart.ApplePayButton:
                    return { data: applePay, disabled, onButtonClick: handleApplePay }
                case Name.Block.Cart.CardForm.Container:
                case Name.Block.Cart.CardFormV1:
                    return { ...billingInfo, refSubmit, onChange: handleBillingInfoChange }
                case Name.Block.Cart.LineItem.List:
                    return { cartData, disabled, onEditionRemove: handleEditionRemove, onLineItemQuantityBlur: handleLineItemQuantityBlur, onLineItemQuantityChange: handleLineItemQuantityChange, onPromoCodeRemove: handlePromoCodeRemove }
                case Name.Block.Cart.PromoCode.Container:
                case Name.Block.Cart.PromoCodeV1:
                    return { disabled, hasActivePromoCodes: cartData.hasActivePromoCodes, onRefreshCart: getCart };
                case Name.Block.Cart.PurchaseButtonV1:
                case Name.Block.Cart.PurchaseButtonV2:
                    return { disabled, formState: billingInfo.formState, onButtonClick: handlePurchase }
                case Name.Block.Inventory.RecentlyViewed.List:
                    return { backgroundColor };
                default:
                    return { cartData };
            }
        },
        Builder.handleBlockProps
    )
    const style = props.style || {}
    if (pageProps) {
        Block.mapStyleConfigProps(style, pageProps.config.layout);
    }
    let className = 'cont--whitelabel';
    if (!props.builder) {
        if (billingInfo.formState == 'processing') {
            style.cursor = 'progress';
        }
        let error;
        if (cartData.hasError && cartData.error) {
            const errorStyles = Block.mapLayoutStyleConfigPropsWithPageKit({ paddingBottom: '20px' }, props);
            error = (
                <div className="error" style={errorStyles.containerStyle}>
                    <div style={errorStyles.style}>
                        {cartData.error}
                    </div>
                </div>
            )
        }
        content = (
            <>
                {error}
                {content}
            </>
        )
    } else {
        className += ' builder';
    }
    return (
        <div className={className} style={style}>
            {content}
        </div>
    )
}
const Controller = withBlockRendering(_CartController);

// region APPLE PAY BUTTON

function _ApplePayButtonComponent(props) {
    if (!props.builder && props.data && props.data.state == 'hidden') {
        return null;
    }
    const style = {}
    Utilities.copyObject(props.style, style);
    if (props.builder || props.disabled) {
        style.pointerEvents = 'none';
    }
    let buttonStyle = 'black';
    if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.style) {
        buttonStyle = props.blockConfig.layout.style;
    }
    let className = `apple-pay-button apple-pay-button-${buttonStyle}`;
    if (style.width) {
        className += ' apple-pay-button-fw';
    }
    return (
        <ButtonWrapper containerStyle={props.containerStyle}>
            <div className="btn--custom2 apple-pay-button-container" style={style}>
                <div className={className} onClick={props.onButtonClick} />
            </div>
        </ButtonWrapper>
    )
}
const ApplePayButtonComponent = withBlockTypeConfigPropsV2(_ApplePayButtonComponent, ['style']);
const ApplePayButton = { Component: ApplePayButtonComponent };

// region LINE ITEMS

function LineItemsComponent(props) {
    const data = props.cartData || {};
    const inventory = [];
    let lineSpacing = '20px';
    let promoCodeContentConfig;
    if (data.lineItems) {
        let inventoryContentConfig;
        if (props.blockConfig && props.blockConfig.block) {
            if (props.blockConfig.block.lineSpacing && props.blockConfig.block.lineSpacing.value && props.blockConfig.block.lineSpacing.unit) {
                lineSpacing = `${props.blockConfig.block.lineSpacing.value}${props.blockConfig.block.lineSpacing.unit}`;
            }
            if (props.blockConfig.block.inventoryLineItemCell && props.blockConfig.block.inventoryLineItemCell.desktop && props.blockConfig.block.inventoryLineItemCell.desktop.blocks && props.blockConfig.block.inventoryLineItemCell.desktop.blocks.length > 0) {
                inventoryContentConfig = props.blockConfig.block.inventoryLineItemCell;
            }
            if (props.blockConfig.block.promoCodeLineItemCell && props.blockConfig.block.promoCodeLineItemCell.desktop && props.blockConfig.block.promoCodeLineItemCell.desktop.blocks && props.blockConfig.block.promoCodeLineItemCell.desktop.blocks.length > 0) {
                promoCodeContentConfig = props.blockConfig.block.promoCodeLineItemCell;
            }
        }
        if (!inventoryContentConfig) {
            inventoryContentConfig = Defaults.Block[Name.Block.Cart.LineItem.List].Cell.InventoryDesign(props.config);
        }
        data.lineItems.forEach(function (d, i) {
            if (!d.inventory || !d.inventory.editions || d.inventory.editions.length == 0) {
                return;
            }
            const edition = d.inventory.editions[0] || {};
            if (d.subtotal) {
                edition.price = d.subtotal.display;
            }
            let style;
            if (i != data.lineItems.length - 1) {
                style = { marginBottom: lineSpacing };
            }
            inventory.push(
                <div key={edition.editionId} style={style}>
                    <InventoryLineItemCellContainer
                        {...props}
                        contentConfig={inventoryContentConfig}
                        data={d}
                        id={edition.editionId}
                        onQuantityChange={props.onLineItemQuantityChange}
                        onQuantityInputBlur={props.onLineItemQuantityBlur}
                        onRemove={props.onEditionRemove} />
                </div>
            );
        });
    }
    if (!promoCodeContentConfig) {
        promoCodeContentConfig = Defaults.Block[Name.Block.Cart.LineItem.List].Cell.PromoCodeDesign(props.config);
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({ width: '100%' }, props);
    if (props.disabled) {
        layoutStyles.style.pointerEvents = 'none';
    }
    let content = (
        <div className="cont--kit__content" style={layoutStyles.style}>
            {inventory}
            {
                data.promoCode &&
                data.promoCode.promoCodeId &&
                <div style={{ marginTop: lineSpacing }}>
                    <PromoCodeLineItemCellContainer
                        {...props}
                        contentConfig={promoCodeContentConfig}
                        data={data.promoCode}
                        onRemove={props.onPromoCodeRemove} />
                </div>
            }
        </div>
    );
    const containerStyle = layoutStyles.containerStyle || {};
    if (props.inLayout) {
        containerStyle.width = '100%';
    }
    if (layoutStyles.containerStyle) {
        content = <div className="cont--kit__wrapper" style={containerStyle}>{content}</div>
    }
    return content;
}
const LineItems = { Component: LineItemsComponent };

// region TOTAL

function TotalComponent(props) {
    let label, labelStyle, totalStyle;
    if (props.blockConfig) {
        if (props.blockConfig.label) {
            labelStyle = {};
            Block.mapStyleConfigProps(labelStyle, props.blockConfig.label, (propName, propValue) => {
                switch (propName) {
                    case 'design':
                        label = propValue;
                        return true;
                }
            });
        }
        if (props.blockConfig.total) {
            totalStyle = {};
            Block.mapStyleConfigProps(totalStyle, props.blockConfig.total, (propName) => {
                switch (propName) {
                    case 'design':
                        return true;
                }
            });
        }
    }
    const parseContent = (props, tokenizedString) => {
        if (!tokenizedString) {
            return '';
        }
        const data = props.cartData || {};
        const design = Token.parseTokenizedString(tokenizedString, (keyword, options) => {
            let replaceString = '';
            switch (keyword) {
                case Token.Cart.EstimatedShipping:
                    if (data.totals && data.totals.shipping && data.totals.shipping.display && data.totals.shipping.display.length > 0 && data.totals.shipping.value > 0) {
                        replaceString = Token.getReplacementString(data.totals.shipping.display, options);
                    }
                    break;
                case Token.Cart.EstimatedTax:
                    if (data.totals && data.totals.tax && data.totals.tax.display && data.totals.tax.display.length > 0 && data.totals.tax.value > 0) {
                        replaceString = Token.getReplacementString(data.totals.tax.display, options);
                    }
                    break;
                case Token.Cart.Subtotal:
                    if (data.totals && data.totals.subtotal && data.totals.subtotal.display && data.totals.subtotal.display.length > 0) {
                        replaceString = Token.getReplacementString(data.totals.subtotal.display, options);
                    }
                    break;
                default:
                    replaceString = undefined;
                    break;
            }
            return replaceString;
        });
        if (Utilities.isHTMLContentEmpty(design)) {
            return '';
        }
        return design;
    }
    const [total, setTotal] = React.useState(undefined);
    React.useEffect(() => {
        setTotal(parseContent(props, props.blockConfig.total.design));
    }, [props.blockConfig.total.design, props.cartData.totals.shipping.value, props.cartData.totals.subtotal.value, props.cartData.totals.tax.value]);

    if (!props.builder && !total) {
        return null;
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({ alignItems: 'center', display: 'flex' }, props);
    let content = (
        <div className="cont--kit__content" style={layoutStyles.style}>
            {
                label &&
                <div className="cont--token" style={labelStyle} dangerouslySetInnerHTML={{ __html: label }} />
            }
            <div className="cont--token" style={totalStyle} dangerouslySetInnerHTML={{ __html: total }} />
            {
                !label &&
                !total &&
                <EmptyPlaceholder />
            }
        </div>
    );
    if (layoutStyles.containerStyle) {
        content = <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>{content}</div>
    }
    return content;
}
const TotalTokens = () => {
    return [
        { display: 'Subtotal', token: Token.Cart.Subtotal },
        { display: 'Estimated Shipping', token: Token.Cart.EstimatedShipping },
        { display: 'Estimated Tax', token: Token.Cart.EstimatedTax }
    ];
}
const Total = { Component: TotalComponent, Tokens: TotalTokens };

export {
    ApplePayButton,
    Controller,
    LineItems,
    Mode,
    Total
};